import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { notification } from "antd";
import { Strings } from "../../../../../dataProvider/localize";
import { copySwmsDraftV2 } from "../../../../../actions/v2/JobSwmsTaskActions";
import styles from "./SwmsCopyConfirmModal.module.css";

const CopyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" className={styles.infoBannerIcon}>
    <path d="M192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-200.6c0-17.4-7.1-34.1-19.7-46.2L370.6 17.8C358.7 6.4 342.8 0 326.3 0L192 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-64 0 0 16-192 0 0-256 16 0 0-64-16 0z" />
  </svg>
);

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor" className={styles.closeBtnIcon}>
    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z" />
  </svg>
);

export default function SwmsCopyConfirmModal({ swms, jobId, onClose }) {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const formName = swms && swms.swms_form_name ? swms.swms_form_name : "SWMS";
  const formNumber = swms && swms.swms_number ? swms.swms_number : "-";

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget && !submitting) {
      onClose();
    }
  };

  const handleCopy = () => {
    if (!swms || !swms.swms_form_id || !jobId) {
      notification.error({
        message: Strings.error_title,
        description: Strings.generic_error,
        className: "ant-error"
      });
      onClose();
      return;
    }

    setSubmitting(true);
    dispatch(copySwmsDraftV2(jobId, swms.swms_form_id)).then((message) => {
      setSubmitting(false);
      notification.success({
        message: Strings.success_title,
        description: message || "SWMS copied successfully.",
        className: "ant-success"
      });
      onClose();
    }).catch((err) => {
      setSubmitting(false);
      notification.error({
        message: Strings.error_title,
        description: err || Strings.generic_error,
        className: "ant-error"
      });
    });
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.headerText}>
            <h3>Copy SWMS</h3>
            <p className={styles.headerSubtitle}>{formName} · {formNumber}</p>
          </div>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            disabled={submitting}
            type="button"
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>

        <div className={styles.body}>
          <div className={styles.infoBanner}>
            <CopyIcon />
            <span>
              Are you sure you want to create a copy of this SWMS? A duplicated draft will be created for this job.
            </span>
          </div>
          <p className={styles.warningText}>
            The copied SWMS will be added as a new draft so it can be reviewed and updated before being sent for approval.
          </p>
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button type="button" className={styles.copyBtn} onClick={handleCopy} disabled={submitting}>
            {submitting ? <CircularProgress size={16} style={{ color: "#fff" }} /> : "Copy SWMS"}
          </button>
        </div>
      </div>
    </div>
  );
}
